(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('productWorkflow', productWorkflow);

    productWorkflow.$inject = ['$q', '$log', '$timeout', 'workspace', 'directUploadFileService', 'modelService', 'modelProcessingService', 'processStatusChecker',
        'pricingService', 'productErrorHandler', 'uploadedModelsService', 'modelFilePreviewService'];

    function productWorkflow($q, $log, $timeout, workspace, directUploadFileService, modelService, modelProcessingService, processStatusChecker, pricingService,
        productErrorHandler, uploadedModelsService, modelFilePreviewService) {

        function instance(product) {
            this.product = product;
            this.notifications = [];
        }

        instance.prototype = {
            run: run,

            refresh: refresh,
            recalculatePrice: recalculatePrice,
            acceptRepair: acceptRepair,
            declineRepair: declineRepair,
            abort: null
        };

        return {
            Instance: instance
        };

        // -------------------------------------------------------------------------------------

        function run(canceler) {
            var self = this;
            var name = self.product.getModelName() || self.product.model.id;
            $log.debug('Run workflow: ' + name);

            self.product.state = "Begin";

            resetIssue.call(self);

            canceler = canceler || $q.defer();
            var tasks = [
                uploadFile,
                createModel,
                getModelInfo,
                processBadModel,
                waitProcessingResult,
                getModelInfo,
                getPreviewInfoAsync,
                checkProcessingResult,
                calculatePrice
            ];

            self.abort = function () {
                if (canceler) {
                    canceler.resolve('ABORT workflow:' + name);
                }
            };

            var flow = $q.resolve(self.product.file);
            _.each(tasks, function (task) {
                flow = flow.then(function (result) {
                    return task.call(self, result, canceler.promise);
                });
            });

            flow = flow.catch(handleException.bind(self));

            flow = flow.finally(function () {
                $log.debug('FINISHED workflow: ' + name);

                self.product.state = 'Ready';

                canceler.reject();
                canceler = null;
            });

            return flow;
        }

        function refresh(canceler) {
            $log.debug('refresh modelId = ' + this.product.model.id + ' product.state = ' + this.product.state);

            this.abort();

            this.product.model.status = angular.undefined;
            this.product.model.result = angular.undefined;
            this.product.salesPrice = null;

            return this.run(canceler);
        }

        function recalculatePrice(canceler) {
            var product = this.product;
            $log.debug('RecalculatePrice modelId = ' + product.model.id + ' product.state = ' + product.state);

            if (product.state !== 'PriceCalculating' && product.state !== 'Ready') {
                return $q.reject('Price can not be recalculated. Invalid state of product. State = ' + product.state);
            }

            if (product.state === 'PriceCalculating') {
                this.abort();
            }

            product.salesPrice = null;

            return this.run(canceler);
        }

        function acceptRepair(canceler) {
            var self = this;
            var model = self.product.model;

            $log.debug('AcceptRepair modelId = ' + model.id);

            return modelService.acceptRepair(model.id, canceler)
                .then(refresh.bind(self))
                .catch(function(reason){                  
                    if (reason === 'CANCELED') {
                        return;
                    }
                
                    self.product.issue = productErrorHandler.handle(self.product, reason);                
                });
        }

        function declineRepair(canceler) {
            var self = this;
            var model = self.product.model;

            $log.debug('DeclineRepair modelId = ' + model.id);

            return modelService.declineRepair(model.id, canceler)
                .then(refresh.bind(self))
                .catch(function(reason){                  
                    if (reason === 'CANCELED') {
                        return;
                    }
                
                    self.product.issue = productErrorHandler.handle(self.product, reason);                
                });
        }

        // ------------------------------------------------------------------------------------

        function handleException(reason) {
            $log.debug("Workflow stopped. Reason: ", reason);
            var self = this;

            if (reason === 'CANCELED') {
                return;
            }

            self.product.salesPrice = null;
            
            var issue = self.product.issue;
            if (!issue || issue.type !== 'NotAcceptedV3Results') {
                this.product.issue = productErrorHandler.handle(this.product, reason);
            }

            // clean model data if needed.
        }

        // ############################################ Tasks ############################################

        // ------------------------------------------ uploadFile ------------------------------------------
        function uploadFile(file, canceler) {
            var self = this;

            if (file) {
                $log.debug('uploadFile');
                self.product.state = 'FileUploading';

                return directUploadFileService.uploadFile(file, canceler)
                    .then(fileUploaded.bind(self), null, notifyFileUploadProgress.bind(self));
            }

            return $q.resolve(null);
        }

        function fileUploaded(uploadedFile) {
            $log.debug("file uploaded ", uploadedFile);

            var product = this.product;
            product.file = null;

            product.uploadedFile = {
                fileId: uploadedFile.fileId,
                fileName: uploadedFile.fileName
            };

            return this.product.uploadedFile;
        }

        function notifyFileUploadProgress(percentages) {
            this.product.upload.progress = percentages;
        }

        // ------------------------------------------ createModel ------------------------------------------

        function createModel(result, canceler) {
            var self = this;
            var product = self.product;

            if (angular.isDefined(product.model.id)) {
                return $q.resolve(product.model.id);
            }

            if (product.uploadedFile) {
                self.product.state = 'ModelCreating';

                return createModelInBackground(product, canceler)
                    .then(function (modelId) {
                        modelCreated.bind(self)(modelId, canceler);
                    });
            }

            return $q.resolve(null);
        }

        function createModelInBackground(product, canceler) {
            $log.debug("createModel for fileName: " + product.getModelName());

            return modelService.createModel(
                product.uploadedFile.fileId,
                product.uploadedFile.fileName,
                product.units,
                product.productTemplateId,
                canceler);
        }

        function modelCreated(modelId) {
            $log.debug("modelCreated modelId =", modelId);

            uploadedModelsService.registerModel(modelId);

            this.product.model.id = modelId;

            return modelId;
        }

        // ------------------------------------------ getModelInfo ------------------------------------------

        function getModelInfo(data, canceler) {
            var product = this.product;

            if (angular.isUndefined(product.model.id)) {
                return $q.reject("Model id does not exists.");
            }

            if (product.model.result && !product.model.result.isUnknown()) {
                return $q.resolve(product.model);
            }

            return getModelInfoWithoutConditions(product, canceler);
        }

        function getModelInfoWithoutConditions(product, canceler) {

            return modelService.getModelInfo(product.model.id, canceler)
                .then(function (modelInfo) {
                    $log.debug("getModelInfo ", modelInfo);

                    product.model = modelInfo;
                    product.units = modelInfo.units;

                    return product.model;
                });
        }

        // ---------------------------------------- processBadModel -------------------------------------

        function processBadModel(model, canceler) {
            var self = this;
            var modelId = self.product.model.id;

            if (angular.isUndefined(modelId)) {
                return $q.reject("Model id does not exists.");
            }

            if (model.status.isDone() && (model.result.isFailed() || model.result.isUnknown())) {
                $log.debug("runProcessForBadModel started for modelId = " + modelId);

                self.product.state = 'ModelCreating';
                model.status = angular.undefined;
                model.result = angular.undefined;

                return modelProcessingService.runProcessForBadModel(modelId, canceler)
                    .then(function () {
                        $log.debug("runProcessForBadModel end for modelId = " + modelId);
                        return getModelInfoWithoutConditions(self.product, canceler);
                    });
            }

            return $q.resolve(model);
        }

        // ---------------------------------------- waitProcessingResult -------------------------------------

        function waitProcessingResult(model, canceler) {
            if (angular.isUndefined(model.status)) {
                return $q.reject('Unknown model status');
            }

            if (model.status.isDone()) {
                return $q.resolve(model.id);
            }

            this.product.state = 'WaitProcessingResult';

            canceler.then(function () {
                var status = model.status;
                if (status && status.isDone()) {
                    return;
                }

                $log.debug("abortProcessing on server side modelId = ", model.id);
                modelProcessingService.abortProcessing(model.id);
            });

            return waitDoneStatusProcessing.call(this, model.id, canceler);
        }

        function waitDoneStatusProcessing(modelId, canceler) {
            if (angular.isUndefined(modelId)) {
                return $q.reject('Model id does not specified');
            }

            $log.debug("waitDoneStatusProcessing modelId = " + modelId);

            var checkerPromise = processStatusChecker.run(modelId, workspace.settings.statusPollingIntervalMs, canceler);
            checkerPromise.finally(null, statusChanged.bind(this));

            return checkerPromise;
        }

        function statusChanged(newStatus) {
            this.product.model.status = newStatus;
        }

        // ---------------------------------------- checkProcessingResult -------------------------------------

        function checkProcessingResult(model) {
            $log.debug('checkProcessingResult modelId = ' + model.id);

            var result = model ? model.result : null;
            if (!result) {
                return $q.reject('Check processing result failed. No results.');
            }

            if (result.isInvalid()) {
                return $q.reject('Invalid model');
            }

            if (result.isAborted()) {
                return $q.reject('Aborted model');
            }

            if (result.isFailed() || result.isUnknown()) {
                return $q.reject('Processing failed');
            }

            if (model.isNeedToApproveRepairModel()) {
                this.product.issue = productErrorHandler.handle(this.product, 'Not accepted V3 results');
            }

            return $q.resolve(model);
        }

        // ---------------------------------------- getPreviewInfoAsync -------------------------------------

        function getPreviewInfoAsync(model, canceler) {
            var result = model ? model.result : null;
            if (!result) {
                return $q.reject('Retrieve preview info failed. No results.');
            }

            if (result.isSucceeded() || result.isInvalid()) {
                if (!model.stripePreviewInfo) {
                    // Call generate stripes after all requests. So, will run generation stripes with low priority and not blocking hight priority requests
                    $timeout(function () {
                        getStripePreviewInfo(model, canceler);
                    });
                }

                if (!model.thumbnailPreviewInfo) {
                    getThumbnailPreviewInfo(model, canceler);
                }
            }

            return $q.resolve(model);
        }

        function getStripePreviewInfo(model, canceler) {
            $log.debug("getStripePreviewInfo without wait results for modelId = " + model.id);

            return modelFilePreviewService.getStripePreviewInfo(model.id, canceler, false)
                .then(function (previewInfo) {
                    $log.debug("Set stripePreviewInfo for modelId = " + model.id);

                    if (angular.isObject(previewInfo)) {
                        model.stripePreviewInfo = previewInfo;
                    } else {
                        if (angular.isString(previewInfo)) {
                            model.stripePreviewInfo = {
                                jobId: previewInfo
                            };
                        }
                    }
                })
                .catch(function () {
                    $log.debug("Can not retrieve stripePreviewInfo for modelId = " + model.id);
                });
        }

        function getThumbnailPreviewInfo(model, canceler) {
            $log.debug("getThumbnailPreviewInfo modelId = " + model.id);

            return modelFilePreviewService.getThumbnailPreviewInfo(model.id, canceler)
                .then(function (previewInfo) {
                    $log.debug("Set thumbnailPreviewInfo for modelId = " + model.id);
                    model.thumbnailPreviewInfo = previewInfo;
                })
                .catch(function () {
                    $log.debug("Can not retrieve thumbnailPreviewInfo for modelId = " + model.id);
                });
        }

        // ---------------------------------------- calculatePrice -------------------------------------

        function calculatePrice(result, canceler) {
            var product = this.product;
            $log.debug("calculatePrice modelId = " + product.model.id);
            product.state = 'PriceCalculating';

            product.salesPrice = angular.undefined;
            return getSalesPrice(product, canceler).then(priceCalculated.bind(this));
        }

        function getSalesPrice(product, canceler) {
            return pricingService.getSalesPrice(product.model.id,
                product.material().id,
                product.colour().id,
                product.scale(),
                product.quantity(),
                product.productTemplateId,
                workspace.settings.currencyId,
                canceler);
        }

        function priceCalculated(salesPrice) {
            this.product.salesPrice = salesPrice;
        }

        // -------------------------------------------------------------------------------------------------

        function resetIssue() {
            this.product.issue = null;
        }
    }
}());